import React, { Component, PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import { NavLink } from 'react-router-dom';

import Alert from '../../components/Form/Alert'

import './ProductBasket.scss';
import Header from './Header';
import Row from './Row';

class BasketFrom extends Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    disabledPeriods: PropTypes.array.isRequired,
    subjects: PropTypes.array.isRequired,
    user: PropTypes.object
  };
  
  renderButton() {
    const { valid, result, user, product } = this.props;
    if (user) {
      if (user.isConfirmed) {
        return (
          <button className="btn btn-primary pull-right" disabled={!(valid && result)}>
            <i className="fa fa-shopping-cart"/> Pievienot grozam
          </button>
        );
      } else {
        return (
          <Alert type="warning" label="Uzmanību!">
            Jūsu lietotāja profilam nepieciešams manuāls apstiprinājums. Jūs saņemsiet ziņu e-pastā par profila apstiprinājumu.
          </Alert>
        )
      }
    }

    return (
      <div className="pull-right">
        <small className="text-muted">Lai turpinātu</small>
        <NavLink className="btn btn-link" to={`/login?next=/browse/${product.object}/${product.id}/`}>
          Ieiet <i className="fa fa-sign-in"/>
        </NavLink>
      </div>
    )
  }

  render() {
    const {
      result,
      handleSubmit,
      subjects,
      disabledPeriods,
    } = this.props;


    return (
      <form onSubmit={handleSubmit} className="basket-form">
        <table className="table table-bordered row-container">
          <thead>
            <Header />
          </thead>
          <tbody>
            <Row subjects={subjects} result={result? result.results : null} disabledPeriods={disabledPeriods} />
          </tbody>
        </table>
        {this.renderButton()}
      </form>
    );
  }
};

export default reduxForm({
  enableReinitialize: true,
  form: 'basket',     // a unique identifier for this form,
  onChange: (data, _, {calculate, valid, ...props}) => calculate(data)
})(BasketFrom);



// WEBPACK FOOTER //
// ./src/containers/ProductBasket/Form.js